export default __webpack_public_path__ + "static/media/nach robh.2065dac3.mp3";